export default "__VITE_ASSET__Gwe7oTNS__"